import {Outlet} from 'react-router';

import {ViewModelProvider} from './ViewModelContext';

const KycInReviewContent = () => {
  return <Outlet />;
};

const KycInReviewPage = () => (
  <ViewModelProvider>
    <KycInReviewContent />
  </ViewModelProvider>
);

export default KycInReviewPage;
